import { render } from "./NewContentEventFlag.vue?vue&type=template&id=461b67d8&scoped=true"
import script from "./NewContentEventFlag.vue?vue&type=script&lang=js"
export * from "./NewContentEventFlag.vue?vue&type=script&lang=js"

import "./NewContentEventFlag.vue?vue&type=style&index=0&id=461b67d8&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-461b67d8"]])

export default __exports__